import React, { useContext, useRef, useState } from "react";
import "../AddChatRoomModal/AddChatRoomModal.css";
import { IoCloseOutline, IoDocumentTextOutline } from "react-icons/io5";
import { TbStack2 } from "react-icons/tb";
import { GrAttachment } from "react-icons/gr";
import { CgCloseO } from "react-icons/cg";
import { useLanguage } from "../../../../LanguageProvider";
import { useToaster } from "../../../../ToasterProvider";
import AddModalInputField from "../../../../components/AddModalInputField/AddModalInputField";
import { GeneralContext } from "../../../../GeneralProvider";
import Services from "../../../../services/Services";

export default function AddAnnouncementModal({
    isOpen,
    onClose,
    selectedChannel,
    fetchAnnouncements
}) {
    const { setCreateProjectLoading } = useContext(GeneralContext);
    const { getTranslation } = useLanguage();
    const { toastWarning, toastSuccess } = useToaster();
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [type, setType] = useState("");
    const [subtitle, setSubtitle] = useState();
    const fileInputRef = useRef();

    if (!isOpen) return null;

    const resetStates = () => {
        setSelectedFiles([])
        setTitle("")
        setDescription("")
        setType("")
        setSubtitle("")
    }

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result.split(",")[1]; // "data:image/jpeg;base64," kısmını kaldırıyoruz
                const extension = file.name.split(".").pop();
                const title =
                    file?.name?.substring(0, file.name.lastIndexOf(".")) || file?.name;
                setSelectedFiles((prevFiles) => [
                    ...prevFiles,
                    { file: base64String, extension: extension, title: title },
                ]);
            };
            reader.readAsDataURL(file);
        });
    };

    const removeFile = (index) => {
        setSelectedFiles((prevFiles) => prevFiles.filter((file, i) => i !== index));
    };

    const createAnnouncement = () => {
        const token = localStorage.getItem("token")
        Services.SocialHiveCreateAnnouncement(token, selectedChannel.channelID, title, description, type, subtitle, selectedFiles[0])
            .then((res) => {
                setCreateProjectLoading(false)
                if (res.data.status) {
                    toastSuccess(getTranslation("successMessage"));
                    onClose();
                    fetchAnnouncements()
                    resetStates();
                } else {
                    toastWarning(res.data.message || getTranslation("somethingWentWrong"));
                }
            })
            .catch((err) => {
                console.error(err);
                toastWarning(getTranslation("somethingWentWrong"));
            });
    }

    const onComplete = () => {
        createAnnouncement()
        resetStates()
        onClose()
    };

    const handleOnClose = () => {
        resetStates()
        onClose()
    }

    return (
        <div className="add-room-modal-overlay">
            <div className="add-room-modal-container">
                <IoCloseOutline
                    className="add-room-modal-button close"
                    onClick={handleOnClose}
                />

                <p className="add-room-modal-title">{getTranslation("createAnnouncement")}</p>

                <AddModalInputField
                    icon={<TbStack2 size={22} style={{ width: "25px" }} />}
                    placeholder={getTranslation("title") + "*"}
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    type={"text"}
                />

                <div className="add-task-modal-content">
                    <IoDocumentTextOutline
                        size={20}
                        style={{
                            width: "25px",
                            alignSelf: "flex-start",
                            marginTop: "10px",
                        }}
                    />
                    <textarea
                        className="add-task-modal-textarea"
                        placeholder={getTranslation("description")}
                        value={description}
                        rows={6}
                        onChange={(e) => setDescription(e.target.value)}
                    ></textarea>
                </div>

                <AddModalInputField
                    icon={<TbStack2 size={22} style={{ width: "25px" }} />}
                    placeholder={getTranslation("type") + "*"}
                    value={type}
                    onChange={(e) => setType(e.target.value)}
                    type={"text"}
                />

                <AddModalInputField
                    icon={<TbStack2 size={22} style={{ width: "25px" }} />}
                    placeholder={getTranslation("subtitle") + "*"}
                    value={subtitle}
                    onChange={(e) => setSubtitle(e.target.value)}
                    type={"text"}
                />



                <div
                    style={{
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: "6px",
                        display: "flex",
                    }}
                >
                    <span
                        style={{
                            width: "100%",
                            flexDirection: "row",
                            alignItems: "center",
                            display: "flex",
                            gap: "5px",
                        }}
                    >
                        <span className="add-room-modal-attachments-icon">
                            <GrAttachment />
                        </span>
                        <span className="add-room-modal-attachments">
                            {getTranslation("uploadBannerImage")}
                        </span>
                    </span>
                    <div className="add-room-modal-select-file-holder">
                        <button
                            className="action-button"
                            onClick={() => fileInputRef.current.click()}
                        >
                            {getTranslation("selectFile")}
                        </button>
                        <input
                            type="file"
                            accept=".png,.jpg,.jpeg,.gif"
                            ref={fileInputRef}
                            style={{ display: "none" }}
                            multiple
                            onChange={handleFileChange}
                        />

                    </div>
                    {selectedFiles.length > 0 && (
                        <div
                            style={{
                                display: "flex",
                                overflowX: "auto",
                                gap: "8px",
                                padding: "8px 0",
                                width: "100%",
                            }}
                        >
                            {selectedFiles.map((file, index) => (
                                <div
                                    className="add-room-modal-added-attachment-chip"
                                    key={index}
                                >
                                    <span className="add-room-modal-added-attachment-chip-title">
                                        {file.title}
                                    </span>
                                    <CgCloseO
                                        onClick={() => removeFile(index)}
                                        style={{
                                            cursor: "var(--pointer)",
                                            minWidth: "14px",
                                            minHeight: "14px",
                                            width: "14px",
                                            height: "14px",
                                        }}
                                    />
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                <div className="add-room-modal-actions">
                    <button
                        onClick={onComplete}
                        className="add-room-modal-button create"
                    >
                        {getTranslation("create")}
                    </button>
                </div>
            </div>
        </div>
    );
}
